import { AuthResponse, Failure, TotpCode } from "@frontend-monorepo/core";
import { Observable } from "rxjs/internal/Observable";
import { TotpToken } from "./models/totp-token";

export abstract class AuthBase {
    abstract postAuthTotp(totpCode: number): Observable<TotpToken | Failure>;
    abstract doLogin(username: string, password: string, remember: boolean): Observable<AuthResponse>;
    abstract doLogout(): Observable<any>;
}